import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { HseTabBar } from "../HseTabBar";

export const COMPETENCY_PATHS = {
  my: "/dashboard/hse-ks/competency",
  definitions: "/dashboard/hse-ks/competency/definitions",
  matrix: "/dashboard/hse-ks/competency/matrix",
  roles: "/dashboard/hse-ks/competency/roles",
  employees: "/dashboard/hse-ks/competency/employees",
  expiring: "/dashboard/hse-ks/competency/expiring",
  courses: "/dashboard/hse-ks/competency/courses",
  trainingPlan: "/dashboard/hse-ks/competency/training-plan",
  training: "/dashboard/hse-ks/competency/training",
  guide: "/dashboard/hse-ks/competency/guide",
};

export const COMPETENCY_TABS = [
  { id: "my", path: COMPETENCY_PATHS.my, labelKey: "hse.competency.nav.my" },
  { id: "definitions", path: COMPETENCY_PATHS.definitions, labelKey: "hse.competency.nav.definitions" },
  { id: "matrix", path: COMPETENCY_PATHS.matrix, labelKey: "hse.competency.nav.matrix" },
  { id: "roles", path: COMPETENCY_PATHS.roles, labelKey: "hse.competency.nav.roles" },
  { id: "employees", path: COMPETENCY_PATHS.employees, labelKey: "hse.competency.nav.employees" },
  { id: "expiring", path: COMPETENCY_PATHS.expiring, labelKey: "hse.competency.nav.expiring" },
  { id: "courses", path: COMPETENCY_PATHS.courses, labelKey: "hse.competency.nav.courses" },
  { id: "training-plan", path: COMPETENCY_PATHS.trainingPlan, labelKey: "hse.competency.nav.training_plan" },
  { id: "training", path: COMPETENCY_PATHS.training, labelKey: "trainingAdmin.title", adminOnly: true },
  { id: "guide", path: COMPETENCY_PATHS.guide, labelKey: "hse.competency.nav.guide" },
];

export function detectCompetencyTab(pathname = "") {
  if (pathname === COMPETENCY_PATHS.training || pathname.startsWith(`${COMPETENCY_PATHS.training}/`)) return "training";
  if (pathname.includes("/definitions")) return "definitions";
  if (pathname.includes("/matrix")) return "matrix";
  if (pathname.includes("/roles")) return "roles";
  if (pathname.includes("/employees")) return "employees";
  if (pathname.includes("/expiring")) return "expiring";
  if (pathname.includes("/courses")) return "courses";
  if (pathname.includes("/training-plan")) return "training-plan";
  if (pathname.includes("/guide")) return "guide";
  return "my";
}

/**
 * Persistent competency admin/subnav — same HseTabBar thread as RiskSubnav.
 */
export function CompetencySubnav({ active }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const isAdmin = useSelector((state) =>
    state.session.currentUser?.roles?.some((role) => role.name === "admin"),
  );
  const activeId = active || detectCompetencyTab(location.pathname);

  return (
    <HseTabBar
      tabs={COMPETENCY_TABS.filter((tab) => !tab.adminOnly || isAdmin).map((tab) => ({
        id: tab.id,
        label: t(tab.labelKey),
        path: tab.path,
      }))}
      activeId={activeId}
      onSelect={(tab) => navigate(tab.path)}
      ariaLabel={t("hse.competency.nav.aria")}
      wrap
    />
  );
}
